import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { env } from '@repo/env';
import { renderStructuredContent } from '../rendererContext';
import type { RendererProps } from '../types';

export async function WPBlock({
  props: { content, id, rendererProps },
}: StructuredContentDocument<{
  id: string;
  content: StructuredContentDocument;
  rendererProps?: RendererProps;
}>) {
  if (!id) {
    if (['stage', 'dev'].includes(env.NEXT_PUBLIC_DEPLOYABLE_ENV)) {
      console.warn('WPBlock Structured Content Renderer missing content for doc');
    }
    return null;
  }
  return renderStructuredContent(content, rendererProps);
}
